import React from "react";

/**
 * Prominent, text-based "CY{year}" pill used on RDP submission routes.
 *
 * Do not rely on color alone — RDPs sign under perjury per filing year and
 * cannot afford ambiguity, so the year always reads as plain text and is
 * mirrored into `aria-label` for assistive tech.
 *
 * Returns `null` when the year is not yet known so callers can render this
 * inside a header layout without conditional spacing logic.
 */
const CalendarYearPill: React.FC<{ year: number | undefined }> = ({ year }) =>
  typeof year === "number" ? (
    <span
      aria-label={`Calendar year ${year}`}
      className="inline-flex items-center rounded-md border border-blue-600 bg-blue-50 text-blue-800 px-3 py-1 text-sm font-semibold"
    >
      {`CY${year}`}
    </span>
  ) : null;

export default CalendarYearPill;
